import { ReactElement } from "react";

import {
  ApplicationAuthorisationGuard,
  ModuleGuardProps,
} from "../../../shared/auth/guards/application-authorisation.guard";
import { useHasPcfAccess } from "../public/use-has-pcf-access";

/** PCF's own guard component. See `application-authorisation.guard.tsx` for why each module has one. */
export const PcfAuthorisationGuard = ({ children }: ModuleGuardProps): ReactElement => {
  const hasAccess = useHasPcfAccess();

  return <ApplicationAuthorisationGuard hasAccess={hasAccess}>{children}</ApplicationAuthorisationGuard>;
};
